import type {
  QueryObserverResult,
  RefetchOptions,
} from '@tanstack/react-query';
import {
  useIntegrations,
  type DecoratedIntegration,
} from '@/pages/Schedule/hooks/useIntegrations';
import { IntegrationType } from '@/types/gql.generated';
import type { QueryError } from '@/utils/errors';

type Ret = {
  data: DecoratedIntegration[];
  error: QueryError | null;
  isPending: boolean;
  refetch: (
    options?: RefetchOptions
  ) => Promise<QueryObserverResult<DecoratedIntegration[], QueryError>>;
};

const filterIntegrations = (
  integrations: DecoratedIntegration[]
): DecoratedIntegration[] => {
  return integrations.filter((item) => item.type === IntegrationType.Canva);
};

export const useCanvaIntegrations = (): Ret => {
  const {
    data: integrations = [],
    error,
    isPending,
    refetch: refetchIntegrations,
  } = useIntegrations();

  const refetch: Ret['refetch'] = async (options) => {
    const res = await refetchIntegrations(options);

    return {
      ...res,
      data: filterIntegrations(res.data || []),
    } as QueryObserverResult<DecoratedIntegration[], QueryError>;
  };

  return {
    data: filterIntegrations(integrations),
    error,
    isPending,
    refetch,
  };
};
